import React from 'react';
import './SkeletonLoader.css';

interface SkeletonLoaderProps {
  type?: 'text' | 'title' | 'avatar' | 'card' | 'custom';
  width?: string | number;
  height?: string | number;
  borderRadius?: string | number;
  count?: number;
  className?: string;
}

const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({
  type = 'text',
  width,
  height,
  borderRadius,
  count = 1,
  className = ''
}) => {
  const getDefaultStyles = () => {
    switch (type) {
      case 'text':
        return { width: width || '100%', height: height || '16px', borderRadius: borderRadius || '4px' };
      case 'title':
        return { width: width || '60%', height: height || '24px', borderRadius: borderRadius || '4px' };
      case 'avatar':
        return { width: width || '48px', height: height || '48px', borderRadius: borderRadius || '50%' };
      case 'card':
        return { width: width || '100%', height: height || '120px', borderRadius: borderRadius || '8px' };
      case 'custom':
        return { width, height, borderRadius };
      default:
        return { width: '100%', height: '16px', borderRadius: '4px' };
    }
  };

  const styles = getDefaultStyles();

  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className={`skeleton-loader ${className}`}
          style={styles}
        />
      ))}
    </>
  );
};

export default SkeletonLoader;